import { hasHash } from "./constants";

/**
 * USER OPERATIONS
 */

//Saves the user token to remember the user
const _storeUser = token => {
  window.localStorage.setItem("portalWebToken", token);
};

//Checks if the user is loggedin
const _isLoggedIn = () => {
  return window.localStorage.getItem("portalWebToken");
};
//Removes the token and logs out the user
const _logout = () => {
  window.localStorage.removeItem("portalWebToken");
  setTimeout(() => {
    _refreshPage();
  }, 200);
};

/**
 * UTILS OPERATIONS
 */
const generateToken = () => {
  return guid();
};

const guid = () => {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + "" + s4() + "" + s4() + "" + s4();
};

const _refreshPage = () => {
  window.location.reload();
};

const smartWidth = (width = 1140) => {
  return (window.innerWidth - width) / 2;
};

const compose = (...funcs) =>
  funcs.reduce((a, b) => (...args) => a(b(...args)), arg => arg);

const validURL = str => {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
};

const is_touch_device = () => {
  const prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  const mq = query => {
    return window.matchMedia(query).matches;
  };

  if (
    "ontouchstart" in window ||
    (window.DocumentTouch && document instanceof "DocumentTouch")
  ) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  let query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
};

// strip html tags
const stripHtml = html => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

// clear hash route
const clearHashRoute = hashRoute => {
  const chars = hashRoute.split("");
  let cleanRoute = hashRoute;
  if (chars[0] === "#") cleanRoute = hashRoute.substr(1);
  return cleanRoute;
};

function changeAccessibilityFilter(value) {
  localStorage.setItem("portalUAAccessibilityFilter", value);
  // window.location.reload();
}

//gets the default or current value for de accessibility filter
function getAccessibilityFilter() {
  if (localStorage.getItem("portalUAAccessibilityFilter") === null) {
    changeAccessibilityFilter(0);
    return 0;
  }
  return localStorage.getItem("portalUAAccessibilityFilter");
}

function changeZoom(value) {
  localStorage.setItem("portalUAZoomFilter", value);
  // window.location.reload();
}

function getZoom() {
  if (localStorage.getItem("portalUAZoomFilter") === null) {
    changeZoom("100%");
    return "100%";
  }
  return localStorage.getItem("portalUAZoomFilter");
}

//gets the cookies bar state
function setCookieBarLocalStorage(hasConsent = true) {
  localStorage.setItem("portalUACookiesBarConsent", hasConsent);
  return hasConsent;
}

function getCookieBarLocalStorage() {
  const cookieBarConsent = localStorage.getItem("portalUACookiesBarConsent");
  if (cookieBarConsent === null) return false;
  return JSON.parse(cookieBarConsent);
}

/**
 * Returns an internal link to a path
 * @param {string} path page path
 * @returns {string} link of the path with language and hash
 */
const internalLink = path => `${hasHash}/pt/${path}`;

const isIE = () => {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");

  // eslint-disable-next-line
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    // If Internet Explorer, return version number
    // alert(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
    return true;
  } // If another browser, return 0

  /*
  if (/Edge\/\d./i.test(navigator.userAgent)){
    // This is Microsoft Edge
   return true;
  }*/

  return false;
};

export {
  _storeUser,
  _isLoggedIn,
  _logout,
  generateToken,
  guid,
  _refreshPage,
  smartWidth,
  compose,
  validURL,
  is_touch_device,
  stripHtml,
  clearHashRoute,
  getAccessibilityFilter,
  changeAccessibilityFilter,
  changeZoom,
  getZoom,
  internalLink,
  setCookieBarLocalStorage,
  getCookieBarLocalStorage,
  isIE
};
